export default __webpack_public_path__ + "d0cf6bcc6b99c858fce6179f7588f84f.svg";